import api from './api';
import axios from 'axios';
import apiRoutes from '../../../api/apiRoutes';
/* =========================
   USER PROFILE
========================= */

/**
 * Fetch current user info
 */
export const fetchUserInfo = async () => {

  const response = await api.get(apiRoutes.users.me);

  return response.data;
};

/**
 * Update current user info
 */
export const updateUserInfo = async (payload) => {

  const response = await api.put(
    apiRoutes.users.me,
    payload
  );

  return response.data;
};

/**
 * Fetch user by ID (admin / agent view)
 */
export const fetchUserById = async (userId) => {

  const response = await api.get(
    apiRoutes.users.detail(userId)
  );

  return response.data;
};


export const updateUserById = async (userId, payload) => {
  const response = await api.put(apiRoutes.users.detail(userId), payload);
  return response.data;
};

/* =========================
   ADDRESS SEARCH (Nominatim)
========================= */

export const searchAddressNominatim = async (query) => {
  if (!query.trim()) return [];
  const response = await axios.get('https://nominatim.openstreetmap.org/search', {
    params: { q: query, format: 'json', addressdetails: 1, limit: 5, countrycodes: 'ir', 'accept-language': 'fa' }
  });
  return response.data;
};


/* =========================
   FAVORITES
========================= */

/**
 * Get user's favorite properties
 */
export const fetchFavorites = async () => {

  const response = await api.get(
    apiRoutes.users.meFavorites
  );

  return response.data;
};

/**
 * Add property to favorites
 */
export const addFavorite = async (propertyId) => {

  const response = await api.post(
    apiRoutes.users.meFavorites,
    {
      property_id: propertyId
    }
  );

  return response.data;
};

/**
 * Remove property from favorites
 */
export const removeFavorite = async (
  propertyId
) => {

  const response = await api.delete(
    apiRoutes.users.meFavorite(propertyId)
  );

  return response.data;
};

/* =========================
   RESERVATIONS
========================= */

/**
 * Get user reservations (sent by the current user as buyer)
 */
export const fetchReservations = async () => {
  const response = await api.get(apiRoutes.dealbridge.reservations, { params: { scope: 'sent' } });
  const data = response.data;
  return Array.isArray(data) ? data : (data.results || []);
};

/**
 * Create reservation request
 */
export const createReservation = async (payload) => {
  const response = await api.post(apiRoutes.dealbridge.reservations, payload);
  return response.data;
};

/**
 * Cancel reservation
 */
export const cancelReservation = async (reservationId, rejectionNote = '') => {
  const response = await api.post(apiRoutes.dealbridge.reservationAction(reservationId, 'cancel'), {
    rejection_note: rejectionNote,
  });
  return response.data;
};

/* =========================
   PROPERTY SHOWINGS
========================= */

/**
 * Fetch scheduled showings (visits)
 */
export const fetchShowings = async () => {

  const response = await api.get(
    apiRoutes.users.meShowings
  );

  return response.data;
};

/**
 * Create a showing request
 */
export const createShowing = async (
  payload
) => {

  const response = await api.post(
    apiRoutes.users.showings,
    payload
  );

  return response.data;
};

/**
 * Cancel showing
 */
export const cancelShowing = async (
  showingId
) => {

  const response = await api.delete(
    apiRoutes.users.showing(showingId)
  );

  return response.data;
};

/* =========================
   RENTED PROPERTIES
========================= */

/**
 * Get properties rented by user
 */
export const fetchRentedProperties = async () => {

  const response = await api.get(
    apiRoutes.users.meRentedProperties
  );

  return response.data;
};
